import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import {
  getPaymentsCall,
  getPendingPaymentsCall,
  getDownloadPaymentReceiptCall,
  postPaymentsCreateCall,
} from './api';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [
  getPaymentsCall.saga,
  getPendingPaymentsCall.saga,
  getDownloadPaymentReceiptCall.saga,
  postPaymentsCreateCall.saga,
];

export function* paymentsRootSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
